const handleDeleteEquipmentModels = {
  text: '¿Realmente quiere eliminar el dispositivo?',
  title: 'ELIMINAR TIPO DEL EQUIPO'
};

export default handleDeleteEquipmentModels;
